'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectResetStyle = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    *,\n    *::before,\n    *::after {\n      box-sizing: border-box; /* 1 */\n    }\n    \n    html {\n      font-family: sans-serif;      \n      -ms-text-size-adjust: 100%; /* 2 */\n      -webkit-text-size-adjust: 100%; /* 2 */\n    }\n    \n    body {\n      margin: 0; /* 3 */\n    }\n    \n    p:first-child { margin-top: 0; }\n    p:last-child { margin-bottom: 0; }\n  '], ['\n    *,\n    *::before,\n    *::after {\n      box-sizing: border-box; /* 1 */\n    }\n    \n    html {\n      font-family: sans-serif;      \n      -ms-text-size-adjust: 100%; /* 2 */\n      -webkit-text-size-adjust: 100%; /* 2 */\n    }\n    \n    body {\n      margin: 0; /* 3 */\n    }\n    \n    p:first-child { margin-top: 0; }\n    p:last-child { margin-bottom: 0; }\n  ']);

var _styledComponents = require('styled-components');

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
/*
 * Reset
 * Normalization of HTML elements
 * We recommend you to use Normalize - https://github.com/necolas/normalize.css
 * or https://github.com/twbs/bootstrap/blob/v4-dev/scss/_reboot.scss
 */

/*
 * 1 - Set box-sizing to border-box to be sure that width isn't affected by
 * padding or border
 *
 * 2 - Prevent adjustments of font size after orientation changes in IE on
 * Windows Phone and in iOS.
 *
 * 3 - Remove the margin in all browsers (opinionated).
 *
*/


var injectResetStyle = exports.injectResetStyle = function injectResetStyle() {
  // eslint-disable-next-line no-unused-expressions
  (0, _styledComponents.injectGlobal)(_templateObject);
};